<section class="dynamic-collapse">
	<section *ngIf="title" class="dynamic-collapse-header">
		<div class="data">
			<svg width="13" height="51" viewBox="0 0 13 51" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M0.478516 6.88888V50.3148H12.8859V6.88889C12.8859 3.46267 10.1084 0.685181 6.68222 0.685181C3.25601 0.685181 0.478516 3.46267 0.478516 6.88888Z"
					class="svg-sign-first-bar" />
			</svg>
			<svg width="14" height="38" viewBox="0 0 14 38" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M0.740723 6.2963V37.3148H13.1481V6.29629C13.1481 2.87008 10.3706 0.0925903 6.94443 0.0925903C3.51822 0.0925903 0.740723 2.87009 0.740723 6.2963Z"
					class="svg-sign-scd-bar" />
			</svg>
			<img class="bottom-bar" src="../../assets/img/bottom-bar.svg" alt="">
		</div>
		<div class="data-info">
			<h3> {{title}}</h3>
			<h2>
				<div class="total-count" *ngIf="total>=0">{{total | currency:'GBP':'symbol-narrow':'1.0'}}</div>
				<div class="total-count" *ngIf="total<0" style="color:red">
					({{total * -1 | currency:'GBP':'symbol-narrow':'1.0'}})
				</div>
			</h2>
		</div>
	</section>
	<section class="dynamic-collapse-main">
		<div class="dynamic-collapse-content">
			<div *ngFor="let item of items;let i = index;">
				<div class="property-row">
					<div class="item-name" (click)="view(item.Id)">{{item.itemName}}</div>
					<div class="item-total" *ngIf="item.itemTotal>=0">
						{{item.itemTotal | currency:'GBP':'symbol-narrow':'1.0'}}</div>
					<div class="item-total" *ngIf="item.itemTotal<0" style="color:red">
						({{item.itemTotal * -1 | currency:'GBP':'symbol-narrow':'1.0'}})
					</div>
				</div>
			</div>
		</div>
	</section>
</section>
